// removed by extract-text-webpack-plugin
module.exports = {"component":"xA6Ube68csc_mqsFiJXCM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Help/Help.css
// module id = 996
// module chunks = 0